// @flow

import fetchPRS from './fetchprs';
import { DaoEndpoint } from './config';
import { handleNetworkError } from './ui';

export const DAO_START = 'DAO_START';
export const DAO_SUCCESS = 'DAO_SUCCESS';
export const DAO_FAILURE = 'DAO_FAILURE';

const daoStart = () => ({ type: DAO_START });

const daoSuccess = data => ({ type: DAO_SUCCESS, payload: data });

const daoFailed = data => ({ type: DAO_FAILURE, payload: data });

export const getDao = () => (dispatch) => {
  const profileId = localStorage.getItem('profileId');
  let daoUrl = DaoEndpoint;
  if (profileId && profileId.length > 0) {
    daoUrl = `${DaoEndpoint}/${profileId}`;
  }
  dispatch(daoStart());
  return fetchPRS(daoUrl, dispatch)
    .then(data => dispatch(daoSuccess(data)))
    .catch((error) => {
      handleNetworkError(dispatch, error);
      dispatch(daoFailed(error));
    });
};

export const defaultState = {
  dao: {
    distributionDate: new Date(),
    distributionAmount: 0,
  },
  fetching: false,
};

const DaoReducer = (state: Object = defaultState, action: Object = {}) => {
  switch (action.type) {
    case DAO_START:
      return Object.assign({}, state, {
        fetching: true,
      });
    case DAO_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        dao: action.payload,
      });
    case DAO_FAILURE:
      return Object.assign({}, state, {
        fetching: false,
        error: action.payload,
      });
    default:
      return state;
  }
};

export default DaoReducer;
